import { lang } from '../provider';

/**
 * Pack of lang terms for the prometheus Pagination component
 */
export function getPaginationI18n() {
    return {
        next: lang.main("Pagination_Next_Page"),
        previous: lang.main("Pagination_Previous_Page"),
        compactText: lang.main("Page_X_of_Y"),
        pageSizes: lang.main("Grid_PageInfoLabelTemplate"),
        pageX: lang.main("Page_X"),
        sizeSelectLabel: lang.main("Pagination_Page_Sizes_Dropdown"),
    }
};
